module.exports = __webpack_public_path__ + "img/EM_Logo.0943efbd.svg";